<template>
    <div class="selector">
        <div class="selector-box" @click="open">
            <span class="selected">{{ (hasNullSelect && value == 'none') ? name : selectedLabel || T('None') }}</span>
            <span class="arrow"></span>
        </div>
        <Dialog ref="selectDialog" :title="title || name">
            <div class="selector-content">
                <ScrollSelect :selectArr="options" :selecKey="tempKey" @change="scrollChange" ></ScrollSelect>
            </div>
            <div class="selector-btn">
                <a class="selector-confilm" @click="selected">{{ T('确认') }}</a>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import ScrollSelect from "@/components/ScrollSelect";

let _this
export default {
    name: 'selector',
    data() {
        _this = this
        return {
            tempKey: 0 // 如果hasNullSelect == true 则 无就是0
        }
    },
    components: {
        Dialog,
        ScrollSelect
    },
    model: {
        prop: 'value',
        event: 'selected'
    },
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        title: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        hasNullSelect: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number],
            default: '0'
        }
    },
    computed: {
        selectedLabel() {
            if (this.options.length) {
                console.log(this.options)
                return this.T(this.options.find(i => i.key == this.value).value)
            }
            return ''
        }
    },
    watch: {
        options: {
            handler(newVal) {
                if (newVal.length && newVal[0].key == 'none') {
                    return
                }
                if (this.hasNullSelect) {
                    this.options.unshift({
                        key: 'none',
                        value: this.T('None')
                    })
                    console.log('options', this.options)
                }
            },
            immediate: true
        }
    },
    methods: {
        open() {
            this.name == 'Kingdom' && console.log('kingDom:', this.value)
            this.tempKey = this.value
            this.$refs.selectDialog.show()
        },
        close() {
            this.$refs.selectDialog.close()
        },
        selected() {
            this.close()
            this.$emit('selected', this.tempKey)
        },
        scrollChange(index) {
            this.tempKey = index
        }
    }
}
</script>

<style lang="scss" scoped>
.selector {
    width: 100%;
    height: 100%;

    .selector-box {
        display: flex;
        min-height: .5rem;
        min-width: 1.95rem;
        align-items: center;
        background: #246bb1;
        color: $text-color_1;
        padding: 0 .15rem;
        cursor: pointer;
    }

    .selected {
        @include ellipsis();
        flex: 1;
        font-size: .2rem;
    }

    .arrow {
        @include bgImg('icon-down.png');
        width: .18rem;
        height: .14rem;
    }
}
.selector-content {
    @include bgImg("lang-decoration.png");
    background-size: 6.27rem 0.86rem;
    background-position: center;
    background-repeat: no-repeat;
}

.selector-btn {
    display: flex;
    justify-content: center;
    padding: 0.15rem 0;

    .selector-confilm {
        @extend .common-btn;
    }
}
</style>